// components/ProtectedRoute.tsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthExt } from "./AuthExt";
// import { useAuthExt } from './AuthExt';

interface ProtectedRouteProps {
    requiredRoles?: string[];
    children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    requiredRoles,
    children,
}) => {
    const auth = useAuthExt();

    if (auth.isLoading) {
        return <div>Loading...</div>;
    }

    if (!auth.isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    if (requiredRoles && !auth.hasAnyPermission(requiredRoles)) {
        return <div>Unauthorized: You do not have access to this page.</div>;
    }

    return <>{children}</>;
};
